import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CostCentreLayer from "../components/CostCentreLayer";

const CostCentrePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Cost Centres">

        {/* CostCentreLayer */}
        <CostCentreLayer />
      </MasterLayout>
    </>
  );
};

export default CostCentrePage;